
import * as Yup from 'yup';
import { Validation } from "constants/Validation";
import { msgTypes } from "constants/msgTypes";

export const GrievenceRedressalSchema = Yup.object().shape({

  redressalId: Yup.string(),
  companyName: Yup.string(),
  address: Yup.string(),
  debtorCompany: Yup.string().required(Validation.required.message.replaceAll("^", "Debtor Company")),
  debtorCompanyAddress: Yup.string(),

  invoiceData: Yup.array().of(
    Yup.object().shape({
      invoiceNumber: Yup.string().required(Validation.required.message.replaceAll("^", "Invoice Number"))
        .matches(Validation.plaintext.regex, Validation.plaintext.message),
      //.required(Validation.required.message.replaceAll("^", "Invoice Number"))
      status: Yup.string().required(Validation.required.message.replaceAll("^", "Status"))
        .matches(Validation.plaintext.regex, Validation.plaintext.message),

      invoice: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
        .test(
          "FILE_FORMAT",
          msgTypes.IMAGE_UNSUPPORTED_FORMAT,
          (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF
          ].includes(value?.type))
        )
        .test(
          "FILE_SIZE",
          msgTypes.FILE_SIZE_MESSAGE_3MB,
          (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
        ),

      currency: Yup.string().required(Validation.required.message.replaceAll("^", "Currency")),
      //.required(Validation.required.message.replaceAll("^", "Currency")),
      invoiceAmount: Yup.string().required(Validation.required.message.replaceAll("^", "Amount"))
            .matches(Validation.amount.regex, Validation.amount.message),
      paidDate: Yup.string().when("status", {
        is: (value) => value === msgTypes.INVOICE_STATUS.PAID,
        then: () => Yup.string().required(Validation.required.message.replaceAll("^", "Paid Date"))
      }),

      dueDate: Yup.string().when("status", {
        is: (value) => value === msgTypes.INVOICE_STATUS.OUTSTANDING,
        then: () => Yup.string().required(Validation.required.message.replaceAll("^", "Due Date"))
      }),

      subject: Yup.string().matches(Validation.plaintext.regex, Validation.plaintext.message),
      
    })
  ),

  currencyData: Yup.array().of(
    Yup.object().shape({
      currency: Yup.string(),
      unpaidAmount: Yup.string().matches(Validation.amount.regex, Validation.amount.message)
    })
  ),

  networkData: Yup.array().of(
    Yup.object().shape({
      networkMembership: Yup.string().matches(Validation.plaintext.regex, Validation.plaintext.message),
      //.required(Validation.required.message.replaceAll("^", "Other Network Membership"))
      contactPerson: Yup.string().matches(Validation.plaintext.regex, Validation.plaintext.message),
      //.required(Validation.required.message.replaceAll("^", "Contact Person"))
      personEmail: Yup.string().matches(Validation.email.regex, Validation.email.message),
      //.email(Validation.email.regex, Validation.email.message)
      //  .required(Validation.required.message.replaceAll("^", "Contact Person's E-mail"))
    })
  ),

  communication: Yup.array().of(
    Yup.object().shape({
      file: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
        .test(
          "FILE_FORMAT",
          msgTypes.IMAGE_UNSUPPORTED_FORMAT,
          (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.WORD, msgTypes.IMAGE_FORMAT.EXCEL, msgTypes.IMAGE_FORMAT.CSV
          ].includes(value?.type))
        )
        .test(
          "FILE_SIZE",
          msgTypes.FILE_SIZE_MESSAGE_3MB,
          (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
        ),
    })
  ),

  accountStatement: Yup.array().of(
    Yup.object().shape({
      file: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
        .test(
          "FILE_FORMAT",
          msgTypes.IMAGE_UNSUPPORTED_FORMAT,
          (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.EXCEL
          ].includes(value?.type))
        )
        .test(
          "FILE_SIZE",
          msgTypes.FILE_SIZE_MESSAGE_3MB,
          (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
        ),
    })
  ),

  shippingDocument: Yup.array().of(
    Yup.object().shape({
      file: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
        .test(
          "FILE_FORMAT",
          msgTypes.IMAGE_UNSUPPORTED_FORMAT,
          (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.WORD, msgTypes.IMAGE_FORMAT.EXCEL, msgTypes.IMAGE_FORMAT.CSV
          ].includes(value?.type))
        )
        .test(
          "FILE_SIZE",
          msgTypes.FILE_SIZE_MESSAGE_3MB,
          (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
        ),
    })
  ),

  deliveryReceipt: Yup.array().of(
    Yup.object().shape({
      file: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
        .test(
          "FILE_FORMAT",
          msgTypes.IMAGE_UNSUPPORTED_FORMAT,
          (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.WORD, msgTypes.IMAGE_FORMAT.EXCEL, msgTypes.IMAGE_FORMAT.CSV
          ].includes(value?.type))
        )
        .test(
          "FILE_SIZE",
          msgTypes.FILE_SIZE_MESSAGE_3MB,
          (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
        ),
    })
  ),

  addentialRevelentDocoument: Yup.array().of(
    Yup.object().shape({
      file: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
        .test(
          "FILE_FORMAT",
          msgTypes.IMAGE_UNSUPPORTED_FORMAT,
          (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.WORD, msgTypes.IMAGE_FORMAT.EXCEL, msgTypes.IMAGE_FORMAT.CSV
          ].includes(value?.type))
        )
        .test(
          "FILE_SIZE",
          msgTypes.FILE_SIZE_MESSAGE_3MB,
          (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
        ),
    })
  ),

  claimForm: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
    .test(
      "FILE_FORMAT",
      msgTypes.IMAGE_UNSUPPORTED_FORMAT,
      (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.WORD
      ].includes(value?.type))
    )
    .test(
      "FILE_SIZE",
      msgTypes.FILE_SIZE_MESSAGE_3MB,
      (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
    ),

  lastDate: Yup.date(),
  //.required(Validation.required.message.replaceAll("^", "Last Contact Date")),

  formContact: Yup.string().matches(Validation.emailOrMobile.regex, Validation.emailOrMobile.message),

  additionalNotes: Yup.string().matches(Validation.plaintext.regex, Validation.plaintext.message),
  //.required(Validation.required.message.replaceAll("^", "Additional Notes")),
  formDeclare: Yup.boolean(),
  termAndCondition: Yup.boolean()

});


